import { QuestionHidden, type IQuestionHidden } from './question-hidden';

export interface IQuestionTitle extends IQuestionHidden<string> {}

export class QuestionTitle
  extends QuestionHidden<string>
  implements IQuestionTitle
{
  constructor(options: IQuestionTitle) {
    super(options);
    this.elementType = 'title';
    this.size = 0;
  }
}
